var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHanLogoFooter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 716.1",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    transform: "translate(0 70.532)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    fill: "#FFFFFF",
    d: "M359.6,488.9c-1,4.2-2.8,8.1-5.3,11.6c-2.5,3.3-5.7,6-9.4,7.8c-4.4,2-9.2,3-14,2.8 c-4.8,0.2-9.6-0.8-13.9-2.8c-3.7-1.8-6.9-4.5-9.3-7.8c-2.5-3.5-4.2-7.4-5.1-11.6c-1.1-4.7-1.6-9.4-1.6-14.2v-61.9h16.3v60.4 c0,2.9,0.2,5.7,0.6,8.6c0.3,2.5,1.1,5,2.2,7.2c1,2,2.4,3.7,4.3,4.9c4.3,2.4,9.5,2.4,13.8,0c1.8-1.2,3.3-2.9,4.3-4.9 c1.1-2.3,1.8-4.7,2.2-7.2c0.4-2.8,0.6-5.7,0.6-8.6v-60.4h16.1v61.9C361.3,479.5,360.7,484.3,359.6,488.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    fill: "#FFFFFF",
    d: "M419.8,508.7l-27.2-67.7h-0.4l0.3,67.7h-14.6v-95.9h18.6l27,68.1h0.4l-0.2-68.1h14.1v95.9 H419.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    fill: "#FFFFFF",
    d: "M454.9,508.7v-95.9h16.3v95.9H454.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    fill: "#FFFFFF",
    d: "M524.7,508.7h-20.6l-23.4-95.9h18.1l16,77h0.4l16-77h17.3L524.7,508.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    fill: "#FFFFFF",
    d: "M558,508.7v-95.9h43v14.4h-27.4v25.5H599v13.3h-25.3v28.3h28.7v14.5H558z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    fill: "#FFFFFF",
    d: "M654.6,508.7l-14.9-40.9h-9.1v40.9h-15.7v-95.9h27.4c3.7,0,7.4,0.5,11,1.6 c3.2,1,6.2,2.7,8.6,4.9c2.5,2.4,4.4,5.3,5.6,8.5c1.4,3.9,2.1,8.1,2,12.3c0.1,3.3-0.4,6.6-1.4,9.8c-0.8,2.6-2,5-3.6,7.2 c-1.3,1.9-2.9,3.5-4.8,4.8c-1.6,1.1-3.3,2-5.2,2.5l17.2,44.2L654.6,508.7z M653.5,440.9c0.1-2.5-0.3-4.9-1.2-7.2 c-0.7-1.7-1.8-3.3-3.2-4.5c-1.3-1.1-2.8-1.9-4.4-2.3c-1.6-0.4-3.2-0.7-4.9-0.7h-9.2v29.5h9.2c3.6,0.1,7.2-1.2,9.8-3.7 C652.4,449.1,653.8,445,653.5,440.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    fill: "#FFFFFF",
    d: "M722.6,431.3c-3.2-4.1-8.1-6.4-13.3-6.4c-1.5,0-3,0.3-4.5,0.7c-3.1,1.1-5.6,3.5-6.7,6.6 c-0.7,1.9-1.1,4-1,6.1c-0.2,3.5,1.1,7,3.7,9.4c2.9,2.5,6.1,4.6,9.6,6.3c2.4,1.2,4.7,2.5,7.2,4.1c2.5,1.5,4.7,3.4,6.6,5.6 c4.6,5,7,11.5,6.8,18.3c0.1,4.3-0.7,8.5-2.2,12.5c-1.4,3.4-3.4,6.5-6,9.1c-2.5,2.5-5.5,4.4-8.7,5.6c-3.4,1.3-7,1.9-10.6,1.9 c-5.1,0-10.1-1-14.8-3.1c-4.1-1.8-7.8-4.5-10.8-7.9l8.8-11.9c2,2.5,4.6,4.5,7.5,6c2.8,1.4,5.9,2.2,9,2.2c3.2,0.1,6.3-1.2,8.5-3.5 c2.4-2.7,3.6-6.3,3.4-9.9c0.2-3.7-1.3-7.4-4.1-9.9c-3.1-2.7-6.6-5-10.3-6.8c-2.6-1.2-5-2.6-7.4-4.2c-2.3-1.5-4.3-3.3-6.1-5.5 c-1.8-2.2-3.2-4.7-4.2-7.5c-1.1-3.3-1.6-6.8-1.6-10.2c-0.1-4.4,0.7-8.7,2.4-12.8c1.4-3.4,3.6-6.4,6.2-8.9c2.5-2.3,5.5-4.1,8.7-5.2 c3.2-1.1,6.5-1.7,9.9-1.7c4.5-0.1,8.9,0.7,13.1,2.4c3.7,1.5,7.1,3.9,9.7,7L722.6,431.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    fill: "#FFFFFF",
    d: "M743.4,508.7v-95.9h16.3v95.9H743.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    fill: "#FFFFFF",
    d: "M802.9,426.6v82.1h-16v-82.1h-18v-13.8h52v13.8H802.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    fill: "#FFFFFF",
    d: "M865.4,472v36.7h-16V472l-24-59.2H843l14.4,42.8l0.4-0.3l14.6-42.5h17.2L865.4,472z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    fill: "#FFFFFF",
    d: "M69,595c0.1,7-0.7,13.9-2.4,20.7c-1.3,5.7-3.6,11-6.8,15.9c-2.8,4.2-6.5,7.8-10.9,10.3 c-9,4.9-19.9,4.9-28.9,0c-4.4-2.5-8.1-6.1-10.8-10.3c-3.2-4.9-5.5-10.3-6.8-15.9C0.7,608.9-0.1,601.9,0,595 c-0.1-6.9,0.7-13.8,2.3-20.6c1.3-5.6,3.6-11,6.8-15.9c2.8-4.2,6.5-7.7,10.9-10.2c9.1-4.8,19.9-4.8,29,0c4.4,2.5,8.1,6,10.9,10.2 c3.2,4.9,5.5,10.2,6.8,15.9C68.3,581.1,69.1,588.1,69,595z M52.2,595c0-4.6-0.4-9.2-1.2-13.7c-0.6-3.8-1.8-7.6-3.4-11.1 c-1.3-2.8-3.2-5.4-5.6-7.4c-2.1-1.8-4.9-2.8-7.7-2.7c-2.8,0-5.6,0.9-7.8,2.7c-2.4,2-4.3,4.5-5.6,7.4c-1.6,3.5-2.7,7.3-3.3,11.1 c-1.4,9.1-1.4,18.4,0,27.5c0.6,3.9,1.7,7.6,3.3,11.2c1.3,2.9,3.2,5.4,5.6,7.5c4.6,3.6,11,3.6,15.6,0c2.4-2,4.3-4.6,5.6-7.5 c1.6-3.6,2.7-7.3,3.3-11.2C51.9,604.2,52.3,599.6,52.2,595z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    fill: "#FFFFFF",
    d: "M99,561.8v26.3h24.7v13.8H99.1v41.2H82.7v-95.9h43v14.6L99,561.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    fill: "#FFFFFF",
    d: "M209.9,643.1l-4.7-20.3H180l-4.9,20.3h-16.2l23.9-95.9h20.7l23.4,95.9H209.9z M193,562.5 h-0.5L182,610h21.1L193,562.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    fill: "#FFFFFF",
    d: "M289.8,575.5c0.1,4.4-0.7,8.7-2.2,12.8c-1.3,3.4-3.3,6.5-5.9,9.1c-2.4,2.4-5.2,4.2-8.4,5.4 c-3.1,1.2-6.4,1.8-9.7,1.8h-11.3v38.5h-16v-95.9h26.5c3.2,0,6.4,0.5,9.5,1.4c3.2,0.9,6.2,2.5,8.7,4.7c2.7,2.4,4.9,5.4,6.4,8.7 C289.1,566.2,290,570.9,289.8,575.5z M274.5,575.7c0.4-4.1-1-8.1-3.7-11.2c-2.5-2.4-5.9-3.6-9.3-3.5h-9.2v30.3h9.2 c3.5,0.1,7-1.3,9.3-4C273.5,584.1,274.8,579.9,274.5,575.7L274.5,575.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    fill: "#FFFFFF",
    d: "M354.4,575.5c0.1,4.4-0.7,8.7-2.2,12.8c-1.3,3.4-3.3,6.5-5.9,9.1c-2.4,2.4-5.2,4.2-8.4,5.4 c-3.1,1.2-6.4,1.8-9.7,1.8h-11.3v38.5h-16v-95.9h26.5c3.2,0,6.4,0.5,9.5,1.4c3.2,0.9,6.2,2.5,8.7,4.7c2.7,2.4,4.9,5.4,6.4,8.7 C353.6,566.2,354.5,570.9,354.4,575.5z M339,575.7c0.4-4.1-1-8.1-3.7-11.2c-2.5-2.4-5.9-3.6-9.3-3.5h-9.2v30.3h9.2 c3.5,0.1,7-1.3,9.3-4C338,584.1,339.3,579.9,339,575.7L339,575.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    fill: "#FFFFFF",
    d: "M365.4,643.1v-95.9h16.4v80.9h26.4v15L365.4,643.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    fill: "#FFFFFF",
    d: "M417.9,643.1v-95.9h16.3v95.9L417.9,643.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    fill: "#FFFFFF",
    d: "M451.4,643.1v-95.9h43v14.3H467V587h25.3v13.3H467v28.3h28.7v14.5L451.4,643.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    fill: "#FFFFFF",
    d: "M569.9,595.3c0.8,12.5-2.6,24.9-9.5,35.3c-6.7,8.5-17.3,13.2-28.1,12.5h-24v-95.9h24.1 c10.8-0.7,21.3,4.1,28,12.7C567.3,570.3,570.7,582.7,569.9,595.3z M553.7,595.3c0.1-5-0.5-10-1.6-14.9c-0.8-3.8-2.3-7.3-4.4-10.6 c-1.7-2.6-4-4.8-6.8-6.3c-2.6-1.4-5.6-2.1-8.5-2.1h-7.7v67.5h7.8c3,0,5.9-0.7,8.5-2.1c2.7-1.5,5.1-3.7,6.8-6.3 c2.1-3.2,3.6-6.8,4.4-10.5C553.2,605.2,553.7,600.2,553.7,595.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    fill: "#FFFFFF",
    d: "M652.1,565.7c-3.2-4.1-8.1-6.4-13.3-6.4c-1.5,0-3,0.2-4.5,0.7c-1.5,0.5-2.8,1.3-3.9,2.4 c-1.2,1.2-2.2,2.6-2.8,4.2c-0.7,2-1.1,4-1,6.1c-0.2,3.5,1.1,7,3.7,9.4c2.9,2.5,6.1,4.6,9.6,6.3c2.4,1.2,4.7,2.5,7.2,4.1 c2.5,1.5,4.7,3.4,6.6,5.6c4.5,5,7,11.5,6.8,18.3c0.1,4.3-0.7,8.5-2.2,12.5c-1.4,3.4-3.4,6.5-6,9.1c-2.5,2.5-5.5,4.4-8.7,5.6 c-3.4,1.3-7,1.9-10.6,1.9c-5.1,0-10.1-1-14.8-3.1c-4.1-1.8-7.8-4.5-10.8-7.9l8.8-11.9c2,2.5,4.6,4.5,7.5,6c2.8,1.4,5.9,2.1,9,2.2 c3.2,0.1,6.3-1.2,8.5-3.5c2.4-2.7,3.6-6.3,3.4-9.9c0.2-3.7-1.3-7.4-4.1-9.9c-3.1-2.7-6.6-5-10.3-6.8c-2.6-1.2-5-2.6-7.4-4.2 c-2.3-1.5-4.3-3.4-6.1-5.5c-1.8-2.2-3.2-4.7-4.2-7.5c-1.1-3.3-1.6-6.8-1.6-10.2c-0.1-4.4,0.7-8.7,2.4-12.8 c1.4-3.4,3.6-6.4,6.2-8.9c2.5-2.3,5.5-4.1,8.7-5.2c3.2-1.1,6.5-1.7,9.9-1.7c4.5-0.1,8.9,0.7,13.1,2.4c3.7,1.5,7.1,3.9,9.7,7 L652.1,565.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    fill: "#FFFFFF",
    d: "M719.7,642c-4.5,2.5-9.7,3.7-14.8,3.5c-5.2,0.1-10.2-1.2-14.7-3.8 c-4.5-2.6-8.3-6.2-11.1-10.5c-3.2-4.9-5.6-10.3-7-15.9c-1.7-6.6-2.6-13.4-2.5-20.2c-0.1-6.8,0.8-13.6,2.5-20.2 c1.4-5.7,3.8-11.1,7.1-16c2.9-4.3,6.7-7.9,11.2-10.4c4.4-2.5,9.5-3.8,14.6-3.7c5-0.1,10,0.9,14.5,3c4.1,2,7.6,5,10.2,8.7 l-9.3,11.4c-3.1-5-8.5-8-14.4-8c-3.1-0.1-6.1,0.9-8.5,2.8c-2.6,2-4.7,4.6-6.1,7.5c-1.7,3.5-3,7.3-3.7,11.2 c-1.6,9.1-1.6,18.3,0,27.4c0.7,3.9,1.9,7.6,3.7,11.2c1.4,2.9,3.5,5.5,6.1,7.5c2.5,1.9,5.6,2.8,8.7,2.8c2.9,0.1,5.8-0.8,8.2-2.4 c2.3-1.6,4.2-3.6,5.8-6l9.4,11C726.9,636.5,723.6,639.7,719.7,642z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    fill: "#FFFFFF",
    d: "M739.7,643.1v-95.9h16.3v95.9L739.7,643.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    fill: "#FFFFFF",
    d: "M773.2,643.1v-95.9h43v14.3h-27.4V587h25.3v13.3h-25.3v28.3h28.7v14.5L773.2,643.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    fill: "#FFFFFF",
    d: "M872.1,643.1l-27.2-67.7h-0.4l0.3,67.7h-14.6v-95.9h18.6l27,68.1h0.4l-0.1-68.1h14.1v95.9 L872.1,643.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    fill: "#FFFFFF",
    d: "M953.6,642c-4.5,2.5-9.7,3.7-14.8,3.5c-5.2,0.1-10.2-1.2-14.7-3.8 c-4.5-2.6-8.3-6.2-11.1-10.5c-3.2-4.9-5.6-10.3-7-15.9c-1.7-6.6-2.6-13.4-2.5-20.2c-0.1-6.8,0.8-13.6,2.5-20.2 c1.4-5.7,3.9-11.1,7.1-16c2.9-4.3,6.7-7.9,11.2-10.4c4.4-2.5,9.5-3.8,14.6-3.7c5-0.1,10,0.9,14.5,3c4.1,2,7.6,5,10.2,8.7 l-9.3,11.4c-3.1-5-8.5-8-14.4-8c-3.1-0.1-6.1,0.9-8.5,2.8c-2.6,2-4.7,4.6-6.1,7.5c-1.8,3.5-3,7.3-3.7,11.2c-1.6,9-1.6,18.3,0,27.4 c0.7,3.9,1.9,7.6,3.7,11.2c1.4,2.9,3.5,5.5,6.1,7.5c2.5,1.9,5.6,2.8,8.7,2.8c2.9,0.1,5.8-0.8,8.2-2.4c2.3-1.6,4.2-3.6,5.8-6 l9.3,11C960.8,636.5,957.5,639.7,953.6,642z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    fill: "#FFFFFF",
    d: "M973.6,643.1v-95.9h43v14.3h-27.4V587h25.3v13.3h-25.3v28.3h28.7v14.5L973.6,643.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    fill: "#FFFFFF",
    d: "M1071.1,565.7c-3.2-4.1-8.1-6.4-13.3-6.4c-1.5,0-3,0.2-4.5,0.7c-1.5,0.5-2.8,1.3-3.9,2.4 c-1.2,1.2-2.2,2.6-2.8,4.2c-0.7,2-1.1,4-1,6.1c-0.2,3.5,1.1,7,3.7,9.4c2.9,2.5,6.1,4.6,9.6,6.3c2.3,1.2,4.8,2.5,7.2,4.1 c2.5,1.5,4.7,3.4,6.6,5.6c4.6,5,7,11.5,6.8,18.3c0.1,4.3-0.7,8.5-2.2,12.5c-1.4,3.4-3.4,6.5-6,9.1c-2.5,2.5-5.5,4.4-8.7,5.6 c-3.4,1.3-7,1.9-10.6,1.9c-5.1,0.1-10.1-1-14.8-3.1c-4.1-1.8-7.8-4.5-10.8-7.9l8.8-11.9c2,2.5,4.6,4.5,7.5,6 c2.8,1.4,5.9,2.1,9,2.2c3.2,0.1,6.3-1.2,8.5-3.5c2.4-2.7,3.6-6.3,3.4-9.9c0.2-3.7-1.3-7.4-4.1-9.9c-3.1-2.7-6.6-5-10.3-6.8 c-2.6-1.2-5-2.6-7.4-4.2c-2.3-1.5-4.3-3.3-6.1-5.5c-1.8-2.2-3.2-4.7-4.2-7.5c-1.1-3.3-1.6-6.8-1.6-10.2c-0.1-4.4,0.7-8.7,2.4-12.8 c1.4-3.4,3.6-6.4,6.2-8.9c2.5-2.3,5.5-4.1,8.7-5.2c3.2-1.1,6.5-1.7,9.9-1.7c4.5-0.1,8.9,0.7,13.1,2.4c3.7,1.5,7.1,3.9,9.7,7 L1071.1,565.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    transform: "translate(0.842 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    transform: "translate(36.254)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    x: 220.8,
    y: 116.1,
    transform: "matrix(0.9511 -0.309 0.309 0.9511 -30.0627 197.603)",
    fill: "#E50056",
    width: 776,
    height: 155.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    transform: "translate(0 70.89)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    transform: "translate(31.861 15.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    fill: "#E50056",
    d: "M258,512.6h-67.7v-10.2H258L258,512.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    fill: "#E50056",
    d: "M49.7,508.3v-42.5H21v42.5H4.9v-95.9H21v38.9h28.7v-38.9h16.1v95.9H49.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    transform: "translate(21.686)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    fill: "#E50056",
    d: "M173,508.3l-27.2-67.7h-0.4l0.3,67.7H131v-95.9h18.6l27,68.1h0.4l-0.1-68.1h14.1v95.9 H173z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    transform: "translate(9.711)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    fill: "#E50056",
    d: "M111,412.4H90.9l-16,64.4l-13.5,4.5l4.2,12.6L71,492l-4.1,16.3h14.8l5.4-21.7l25.5-8.6 l7.6,30.2H135L111,412.4z M90.9,471.4l9.5-38.3h1l8,32.1L90.9,471.4z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHanLogoFooter);
export default __webpack_public_path__ + "static/media/han_logo_footer.4a6f327bf81a370a1ed118ce8440eacf.svg";
export { ForwardRef as ReactComponent };